module.exports = __webpack_public_path__ + "media/soundtrack.ecf87d2c.mp3";